module.exports = __webpack_public_path__ + "img/next.102aab58.png";